/* eslint-disable max-len */
import {Button} from '@/components/common-components/v2';
import {useStore} from '@/store/root-store';
import {formatLargeNumber, formatNumber} from '@/utils/number';
import {faRotateRight} from '@fortawesome/pro-regular-svg-icons';
import {faArrowLeft, faCaretDown} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Divider, Dropdown, Tooltip} from 'antd';
import {observer} from 'mobx-react';
import {useRouter} from 'next/router';
import Flag from '@/components/common-components/components/flag';
import styled from 'styled-components';
import {SkeletonHorizontalLoaderGray, SkeletonRingLoader} from '@/components/common-components/components';
import {getFeatureIcons} from '@/utils/icons';
import {Globe} from 'react-feather';
import {faFileArrowDown} from '@fortawesome/pro-solid-svg-icons';
import React, {useState, useEffect, useMemo, useRef, useCallback} from 'react';
import {getDomain, getSingleUrlParam, isPublicKeywordResearcherV2} from '@/utils/url';
import {titleCase, truncate} from '@/utils/string';
import {CreateList} from '../main-page/createlist';
import ReactEcharts from 'echarts-for-react';
import {graphic} from 'echarts';
import {EmptyStateKeDetail} from './components/emptyStateKe';
import {LoadingOutlined} from '@ant-design/icons';
import {faSquareQuestion} from '@fortawesome/pro-duotone-svg-icons';
import {KeDeleteModal} from '../main-page/component/keDeleteModal';
import {VerticalBar} from '@/components/common-components/components/vertical-bar';
import {AddKeywordDropdownV2} from '@/components/common-components/v2/addKeywordDropdown';
import {getBgAndColorTooltip} from '../magickeyword/collapse-table';
import {PublicPageBanner} from '../ke-common-components-v2/publicPageBanner';
import {notification} from '@/utils/notification';
import {linkgraphDomains} from '@/utils/router';
import {apiError} from '@/utils/api';
import {getLastUpdated} from '@/utils/functions';

export const Header = observer(({fromDrawer=false, handleExportPdf=()=>{}}) => {
  const {
    countries: {getSpecificCountryByCode},
    keywordResearcherV2: {
      loadAddKeywordsList,
      getKeywordListDetail,
      keywordDetails: {
        keSelectedKeyword,
        keywordToShow,
        getKeywordDetailList,
        isExporting,
        getKeywordDetailsData,
        loadingKeywordMainDetails,
        getSerpOverviewDetails,
        getRefetchDataV2,
        loadingRefetchData,
      },
      keywordRankTracker: {
        getListWithoutRepoll,
        getRankTrackerList,
      },
    },
  } = useStore('');
  const {settings: {customer: {isGHLAccount}}} = useStore('');
  const {keywordResearcherV2: {deleteKeywordLoading, deletedKeywordListData, setModaValue, openKeywordDeleteModal, keywordDeleteId}} = useStore('');
  const {settings: {customer: {setAuthModal, profile: {quotaUtilization, isWhitelabel}}}} = useStore('');
  const {plans: {showSidebarPaymentDrawer}} = useStore('');
  const currentDomain = getDomain(window.location.hostname);
  const isWhiteLabelDomain = !linkgraphDomains.includes(currentDomain);

  const [loading, setLoading] = useState(true);
  const metricsData = getKeywordDetailsData?.metrics ? getKeywordDetailsData?.metrics : {} as any;
  const keywordDifficulty = getKeywordDetailsData?.metrics?.rankingDifficulty ? getKeywordDetailsData?.metrics?.rankingDifficulty : {} as any;
  const adsData = getKeywordDetailsData?.metrics?.ads ? getKeywordDetailsData?.metrics?.ads : [];
  const [titleModel] = useState('Create Keyword List');
  const [buttonName] = useState('Create List');
  const router = useRouter();
  const [listName, setListName] = useState('');
  const locationId = getSingleUrlParam('locationId');
  const countryCode = getSingleUrlParam('countryCode');
  const countryName = getSingleUrlParam('countryName');
  const fromKmt = getSingleUrlParam('fromKmt');
  const listNameParam = getSingleUrlParam('listName');
  const [placement, setPlacement] = useState<'top' | 'bottom'>('top');
  const [hovered, setHovered] = useState(false);
  const ref = useRef(null);

  const [newKeyword, setNewKeyword] = useState('');
  const [selectedCountry, setSelectedCountry] = useState({
    locationId: 2840,
    countryCode: 'US',
  });
  const closeModal= ()=>{
    setModaValue(false);
  };
  const lastUpdatedTime = useMemo(() => getLastUpdated(getKeywordDetailsData?.lastUpdatedAt), [getKeywordDetailsData?.lastUpdatedAt]);

  const onDeleteKeyword= async ()=>{
    try {
      await deletedKeywordListData(keywordDeleteId, false);
      closeModal();
      router.push(`/research/keyword-researcher`);
    } catch (error) {
      const errorMessage = apiError(error) as string;
      notification.error('', errorMessage);
    }
  };

  const diffucultyChartData = keywordDifficulty?.difficulty;
  const chartOption={
    series: [
      {
        min: 0,
        max: 10,
        startAngle: 200,
        endAngle: 170,
        type: 'gauge',
        axisLine: {
          roundCap: true,
          lineStyle: {
            width: 15,
            color: [[1, diffucultyChartData > 0? new graphic.LinearGradient(0, 1, 0, 0, [
              {
                offset: 0,
                color: '#1FAC47',
              },
              {
                offset: 1,
                color: '#d8e15e',
              }]) : !fromDrawer ? '#4E5156' : '#e8e8e8']],
          },
        },
        pointer: {
          icon: 'roundRect',
          width: 5,
          show: (diffucultyChartData > 0 && diffucultyChartData < 11) ? true : false,
          length: 23,
          offsetCenter: [0, '-35'],
          itemStyle: {
            color: fromDrawer ? '#4E5156' : '#fff',
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        splitLine: {
          show: false,
          distance: -15,
          length: 15,
          lineStyle: {
            color: '#2D2F34',
            width: 5,
          },
        },
        splitNumber: 0,
        detail: {
          show: true,
          offsetCenter: [0, '0%'],
          valueAnimation: true,
          formatter: value => value || value==0 ? `${value}` : 'N/A',
          color: diffucultyChartData && !fromDrawer ? '#fff' : '#4E5156',
          fontSize: 24,
        },
        data: [diffucultyChartData],
      },
      {
        min: 10,
        max: 30,
        startAngle: 170,
        endAngle: 130,
        type: 'gauge',
        axisLine: {
          lineStyle: {
            width: 15,
            color: [[1, diffucultyChartData > 10 ? new graphic.LinearGradient(0, 1, 0, 0, [
              {
                offset: 0,
                color: '#d8e15e',
              },
              {
                offset: 1,
                color: '#F1AA3E',
              }]) : !fromDrawer ? '#4E5156' : '#e8e8e8']],
          },
        },
        pointer: {
          icon: 'roundRect',
          width: 5,
          show: (diffucultyChartData > 10 && diffucultyChartData < 31) ? true : false,
          length: 23,
          offsetCenter: [0, '-35'],
          itemStyle: {
            color: fromDrawer ? '#4E5156' : '#fff',
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        splitLine: {
          show: true,
          distance: -15,
          length: 15,
          lineStyle: {
            color: '#2D2F34',
            width: 5,
          },
        },
        splitNumber: 0,
        detail: {
          show: false,
        },
        data: [diffucultyChartData],
      },
      {
        min: 30,
        max: 70,
        startAngle: 130,
        endAngle: 40,
        type: 'gauge',
        axisLine: {
          lineStyle: {
            width: 15,
            color: [[1, diffucultyChartData >30 ? new graphic.LinearGradient(1, 0, 0, 0, [
              {
                offset: 0,
                color: '#F65140',
              },
              {
                offset: 1,
                color: '#F1AA3E',
              }]) : !fromDrawer ? '#4E5156' : '#e8e8e8']],
          },
        },
        pointer: {
          icon: 'roundRect',
          width: 5,
          show: (diffucultyChartData > 30 && diffucultyChartData < 71) ? true : false,
          length: 23,
          offsetCenter: [0, '-35'],
          itemStyle: {
            color: fromDrawer ? '#4E5156' : '#fff',
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        splitLine: {
          show: true,
          distance: -15,
          length: 15,
          lineStyle: {
            color: '#2D2F34',
            width: 5,
          },
        },
        splitNumber: 0,
        detail: {
          show: false,
        },
        data: [diffucultyChartData],
      },
      {
        min: 70,
        max: 95,
        startAngle: 40,
        endAngle: -10,
        type: 'gauge',
        axisLine: {
          lineStyle: {
            width: 15,
            color: [[1, diffucultyChartData > 70 ? new graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#ff6536',
              },
              {
                offset: 1,
                color: '#F44343',
              }]): !fromDrawer ? '#4E5156' : '#e8e8e8']],
          },
        },
        pointer: {
          icon: 'roundRect',
          width: 5,
          show: (diffucultyChartData > 70 && diffucultyChartData < 90) ? true : false,
          length: 23,
          offsetCenter: [0, '-35'],
          itemStyle: {
            color: fromDrawer ? '#4E5156' : '#fff',
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        splitLine: {
          show: true,
          distance: -15,
          length: 15,
          lineStyle: {
            color: '#2D2F34',
            width: 5,
          },
        },
        splitNumber: 0,
        detail: {
          show: false,
        },
        data: [diffucultyChartData],
      },
      {
        min: 95,
        max: 100,
        startAngle: -10,
        endAngle: -20,
        type: 'gauge',
        axisLine: {
          roundCap: true,
          lineStyle: {
            width: 15,
            color: [[1, diffucultyChartData > 70 ? new graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#F44343',
              },
              {
                offset: 1,
                color: '#F44343',
              }]): !fromDrawer ? '#4E5156' : '#e8e8e8']],
          },
        },
        pointer: {
          icon: 'roundRect',
          width: 5,
          show: (diffucultyChartData > 89 && diffucultyChartData < 101) ? true : false,
          length: 23,
          offsetCenter: [0, '-35'],
          itemStyle: {
            color: fromDrawer ? '#4E5156' : '#fff',
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        splitLine: {
          show: false,
          distance: -15,
          length: 15,
          lineStyle: {
            color: '#2D2F34',
            width: 5,
          },
        },
        splitNumber: 0,
        detail: {
          show: false,
        },
        data: [diffucultyChartData],
      },
    ],
  };
  const listId = router.query?.keyword?.length ? router.query.keyword[0] : '';

  useEffect(() => {
    if (listId !== 'new') {
      setLoading(false);
    }
  }, [listId]);

  const dummyArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
  const isQuotaremaining = quotaUtilization?.ke?.maxKeywordLookups?.consumed >= quotaUtilization?.ke?.maxKeywordLookups?.total;
  useEffect(() => {
    if (isQuotaremaining) {
      if (isWhitelabel) {
        if (isGHLAccount) {
          notification.error('', "You've reached the limit to optimize this page. Need more? Reach out to our support team for help!");
        } else {
          notification.error('Quota is exceeded', 'You’ve exceeded the usage limit for this tool.');
        }
      } else {
        if (!isGHLAccount) {
          showSidebarPaymentDrawer();
        }
      }
    } else {
      if (!isPublicKeywordResearcherV2() && !fromDrawer) {
        loadAddKeywordsList(false);
        getListWithoutRepoll();
        // getList();
      }
    }
  }, []);
  const handleRefetch = ()=>{
    if (!isPublicKeywordResearcherV2()) {
      getRefetchDataV2(router.query.keyword[0], router?.query?.keyword[1]?.replaceAll('+', ' '), countryCode);
    }
  };

  const getKetwordList = ()=>{
    return (<DropDownWrapper>
      {getKeywordDetailList?.keywords?.map((item, idx)=>{
        const lastid = idx==getKeywordDetailList?.keywords?.length-1;
        return (
          <WrapperDropDown last={lastid} onClick={()=>router.push(`/research/keyword-researcher/${listId}/${getKeywordDetailList?.keywords[idx]?.keyword}?${locationId ? `locationId=${locationId}` : `countryCode=${countryCode ? countryCode : ''}`}`)} key={idx}>{item?.keyword}</WrapperDropDown>
        );
      })}

    </DropDownWrapper>);
  };
  const getBgAndColor =searchIntent=>{
    switch (searchIntent) {
      case 'commercial':
        return {
          background: '#F1AA3E33',
          color: '#F1AA3E',
        };
      case 'navigational':
        return {
          background: '#B98CE433',
          color: '#B98CE4',
        };
      case 'informational':
        return {
          background: '#34AEF333',
          color: '#34AEF3',
        };
      case 'transactional':
        return {
          background: '#1FAC4733',
          color: '#1FAC47',
        };
      default:
        break;
    }
  };
  const handleBackRedirect = () => {
    if (isPublicKeywordResearcherV2()) {
      router?.push('/research/keyword-researcher-public');
    } else if (fromKmt) {
      router.push(`/research/keyword-magic-tool`);
    } else {
      if (getKeywordDetailList?.keywords?.length == 1) {
        router.push(`/research/keyword-researcher`);
      } else {
        router.push(`/research/keyword-researcher-magic/${listId}/${router?.query?.keyword[1]?.replaceAll(' ', '+')}?locationId=${locationId}&countryCode=${countryCode}&countryName=${countryName}${listNameParam ? `&listName=${listNameParam}` : ''}`);
      }
    }
  };
  const updatePlacement = useCallback(() => {
    const element = ref.current;
    if (!element) return;

    const {top, bottom} = element.getBoundingClientRect();
    const spaceAbove = top;
    const spaceBelow = window.innerHeight - bottom;
    const newPlacement = spaceAbove < 98 && spaceBelow > 80 ? 'bottom' : 'top';
    setPlacement(prev => (prev !== newPlacement ? newPlacement : prev));
  }, []);

  useEffect(() => {
    if (!hovered) return;
    window.addEventListener('scroll', updatePlacement, true);
    window.addEventListener('resize', updatePlacement);
    return () => {
      window.removeEventListener('scroll', updatePlacement, true);
      window.removeEventListener('resize', updatePlacement);
    };
  }, [hovered, updatePlacement]);
  const antIcon = <LoadingOutlined style={{fontSize: 12, marginBottom: 2, marginLeft: 5, color: '#7f4ead'}} spin />;
  return <Container fromDrawer={fromDrawer} className={!fromDrawer ? 'bg-main-color' : ''}>
    {fromDrawer ? '' : <Wrapper>
      <HeadingContainer>
        {isWhiteLabelDomain && isPublicKeywordResearcherV2() ? null : <FontAwesomeIcon icon={faArrowLeft} style={{cursor: 'pointer'}} onClick={handleBackRedirect}/>}
        <div style={{marginLeft: '12px'}}>
          {isWhiteLabelDomain && isPublicKeywordResearcherV2() ? <div style={{minWidth: '200px'}}><Heading>Keyword: {keywordToShow ? keywordToShow : router?.query?.keyword?.length ? router?.query?.keyword[1]?.replaceAll('+', ' ') : 'keyword'}
          </Heading></div> : <Dropdown trigger={['click']} overlayStyle={{minWidth: '200px', border: '1px solid #E8E8E8', borderRadius: '5px', background: '#fff'}} overlay={getKetwordList} placement='bottomLeft'>
            <Heading>Keyword: {keywordToShow ? keywordToShow : router?.query?.keyword?.length ? router?.query?.keyword[1]?.replaceAll('+', ' ') : 'keyword'}
              <span style={{cursor: 'pointer'}}> &nbsp;<FontAwesomeIcon icon={faCaretDown} color='#FFFFFF' /></span></Heading></Dropdown>}
        </div>
      </HeadingContainer>
      <ButtonsContainer>
        <SubWrapper>
          <LastUpdate>Last Updated: {lastUpdatedTime}&nbsp;&nbsp;{isWhiteLabelDomain && isPublicKeywordResearcherV2() ? null : loadingRefetchData || loadingKeywordMainDetails ? <FontAwesomeIconStyled color={'#8860D4'} icon={faRotateRight} /> : <FontAwesomeIcon onClick={()=>handleRefetch()} style={{cursor: 'pointer'}} icon={faRotateRight}/>}</LastUpdate>
        </SubWrapper>
        {isWhiteLabelDomain && isPublicKeywordResearcherV2() ? null :<Tooltip title={'Export to pdf'} placement={'bottom'}>
          <ButtonStyled loading={isExporting} variant='ghost' color='textGrayLight' background='rgba(78, 81, 86, 0.1)' onClick={() => {
            if (isPublicKeywordResearcherV2()) {
              setAuthModal(true, false);
            } else {
              handleExportPdf();
            }
          }}><FontAwesomeIcon icon={faFileArrowDown} color='#fff' width='12px'/>&nbsp;Export</ButtonStyled></Tooltip>}
        {isWhiteLabelDomain && isPublicKeywordResearcherV2() ? null : <AddKeywordDropdownV2 keList={getKeywordListDetail} targetKeyword={keSelectedKeyword} rankTrackerList={getRankTrackerList?.results}/>}
      </ButtonsContainer>
    </Wrapper>}
    {getKeywordDetailsData?.searchIntent ?
      <IntnetWrapper
        ref={ref}
        onMouseEnter={() => {
          setHovered(true);
          updatePlacement();
        }}
        onMouseLeave={() => setHovered(false)}>
        <IntentText fromDrawer={fromDrawer}>Search intent: </IntentText>
        {getKeywordDetailsData?.searchIntentList?.map((items, idx)=>
          <Tooltip
            placement={`${placement}`}
            key={idx} color='#121212' title={getBgAndColorTooltip(items)?.tooltipTitle}><Intent intent={getBgAndColor(items)}>{items}</Intent></Tooltip>)}
      </IntnetWrapper> : ''}
    {isPublicKeywordResearcherV2() && isWhiteLabelDomain ? null : isPublicKeywordResearcherV2() && <PublicPageBanner />}
    <CardsContainer>
      <Box className='box' difficulty={keywordDifficulty?.difficulty} fromDrawer={fromDrawer}>
        {loading && loadingKeywordMainDetails ?<>
          <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'60%'} />
          <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'80%'}
            marginTop= '10px' />
          <SkeletonHorizontalLoaderGray marginTop= '10px' align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'60%'} />
          <SkeletonHorizontalLoaderGray marginTop= '10px' align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'80%'} />
        </> :
          <>
            <BoxTitle fromDrawer={fromDrawer}>Keyword Difficulty&nbsp;&nbsp;
              <Tooltip title={<TooltipDescriptionWrapper>
                Keyword Difficulty (KD) in Search Atlas looks at the lower 20th percentile of Domain Rating across the top 20 SERPs. Keywords with lower KDs will have sites ranking in the first two pages of Google that have low Authority, making it possible to rank for these keywords with the right holistic onpage SEO strategy.
              </TooltipDescriptionWrapper>} placement={'bottom'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px'}}><FontAwesomeIcon color={fromDrawer ? '#121212' : '#DADADA'} icon={faSquareQuestion} style={{fontSize: '12px'}}/> </Tooltip>
              <span>{loading && loadingKeywordMainDetails ? antIcon : ''}</span></BoxTitle>
            {loadingKeywordMainDetails ? <SkeletonRingLoader backgroundColor='transparent'/> :
              <BoxMainContent style={{marginTop: '-13px', marginLeft: '-20px', display: 'flex'}}>
                <BoxDescription style={{maxWidth: '130px'}}>
                  <ReactEcharts
                    style={{width: 145, height: 180}}
                    option={chartOption} />
                </BoxDescription>
                <BoxDescription style={{marginTop: '-20px'}} fromDrawer={fromDrawer}>
                  <div>
                    <KeywordLabelHeading fromDrawer={fromDrawer}>{(keywordDifficulty?.difficulty || keywordDifficulty?.difficulty ==0) &&keywordDifficulty?.label ? keywordDifficulty?.label : ''}</KeywordLabelHeading>
                    {keywordDifficulty?.description || ''}
                  </div>
                </BoxDescription>
              </BoxMainContent>
            }
          </>}
      </Box>

      <Box className='box' fromDrawer={fromDrawer}>
        {loading && loadingKeywordMainDetails ?<>
          <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'60%'} />
          <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'80%'}
            marginTop= '10px' />
          <SkeletonHorizontalLoaderGray marginTop= '10px' align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'60%'} />
          <SkeletonHorizontalLoaderGray marginTop= '10px' align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'80%'} />
        </> :
          <>
            <BoxTitle fromDrawer={fromDrawer}>AVERAGE MONTHLY SEARCHES&nbsp;&nbsp;<Tooltip title={<TooltipDescriptionWrapper>
              The average number of times people search for a keyword and similar terms based on the month range, the location and your Search Network settings. This information shows how popular your keywords are during different times of the year. This range is averaged over a 12-month period.
            </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px', width: '300px'}}><FontAwesomeIcon icon={faSquareQuestion} color={fromDrawer ? '#121212' : '#DADADA'} style={{fontSize: '12px'}}/></Tooltip>
            </BoxTitle>
            {loadingKeywordMainDetails ? <SkeletonRingLoader backgroundColor='transparent'/> :
              metricsData?.sv || metricsData?.desktopSearches || metricsData?.mobileSearches || getSerpOverviewDetails?.serpFeatures?.length ?
                <>
                  <BoxMainContent>
                    {getKeywordDetailsData?.locationFlag ? <Flag code={getKeywordDetailsData?.locationFlag?.toUpperCase()} height={10} width={20}/> : (
                      getKeywordDetailsData?.countryCode ? <Flag code={getKeywordDetailsData?.countryCode?.toUpperCase()} height={10} width={20}/> : <GlobeStyled fromDrawer={fromDrawer}/>)}
                    <BoldValue fromDrawer={fromDrawer}>{metricsData?.sv ? formatLargeNumber(metricsData?.sv, 1)?.toString()?.replace('.0', '') : '0'}</BoldValue>
                  </BoxMainContent>
                  <BoxDescription fromDrawer={fromDrawer}>Location: {getKeywordDetailsData?.location ? getKeywordDetailsData?.location : getKeywordDetailsData?.countryCode ? getSpecificCountryByCode(getKeywordDetailsData?.countryCode?.toUpperCase())?.name : 'worldwide'}</BoxDescription>
                  <div style={{display: 'flex', gap: '10px'}}>
                    { metricsData?.desktopSearches ? <BoxDescription fromDrawer={fromDrawer}>Desktop:   {formatLargeNumber(metricsData?.desktopSearches, 1)?.toString()?.replace('.0', '') }</BoxDescription> : ''}
                    {metricsData?.mobileSearches ? <BoxDescription fromDrawer={fromDrawer}>Mobile:  { formatLargeNumber(metricsData?.mobileSearches, 1)?.toString()?.replace('.0', '')}</BoxDescription> : ''}
                  </div>
                  {getSerpOverviewDetails?.serpFeatures?.length ? <Tooltip title={<TooltipDescriptionWrapper>
              SERP features are any results on a Google Search Engine Results Page (SERP) that is not a traditional organic result. These can include, but are not limited to: direct answers, sitelinks, carousels, images/videos etc. Hover on an icon to view the SERP feature.
                  </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px', width: '300px'}}> <BoxDescription style={{marginTop: '8px'}} fromDrawer={fromDrawer}>SERP Features:</BoxDescription></Tooltip> : ''}
                  <Tooltip title={
                    <SerpToolTipWrapper>
                      <SerpHeading>SERP FEATURES </SerpHeading>
                      <SerpToolTipContainer style={{paddingTop: '10px'}}>{getSerpOverviewDetails?.serpFeatures?.map((item, idx) => {
                        return <div style={{display: 'flex'}} key = {idx}>
                          <span style={{width: '22px'}} key={`id_${item}`}>{item ? getFeatureIcons(item) : ''}</span>
                          <span style={{color: '#121212', overflow: 'hidden'}}>{item && item != 'organic' ? titleCase(item) : ''}</span>
                        </div>;
                      })}</SerpToolTipContainer>
                    </SerpToolTipWrapper>
                  } placement={'bottomLeft'} color='#fff' overlayStyle={{minWidth: '171px'}} overlayInnerStyle={{borderRadius: '6px'}}>
                    <SerpContainer fromDrawer={fromDrawer}>{getSerpOverviewDetails?.serpFeatures?.map(item => {
                      return <span key={`id_${item}`}>{item ? getFeatureIcons(item) : ''}</span>;
                    })}</SerpContainer></Tooltip> </>:
                <EmptyStateKeDetail countryCode={getKeywordDetailsData?.countryCode?.toUpperCase() || getKeywordDetailsData?.locationFlag?.toUpperCase()} isFlag={true} isHeader={true} headDescription={'Volume data not found'}/>

            }
          </>}
      </Box>
      <Box className='box' fromDrawer={fromDrawer}>
        {loading && loadingKeywordMainDetails ?<>
          <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'60%'} />
          <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'80%'}
            marginTop= '10px' />
          <SkeletonHorizontalLoaderGray marginTop= '10px' align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'60%'} />
          <SkeletonHorizontalLoaderGray marginTop= '10px' align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'80%'} />
        </> :
          <>
            <BoxTitle style={{minWidth: '180px'}} fromDrawer={fromDrawer}>Topical Search Volume&nbsp;&nbsp; <Tooltip title={<TooltipDescriptionWrapper>
              {`Topical search volume refers to the number of searches conducted for a specific topic or theme over a given period. Unlike keyword search volume, which focuses on the frequency of searches for a particular keyword or phrase, topical search volume encompasses all related searches within a broader topic area.`}<br/>
              {`For example, for the keyword "healthy eating," it includes searches for "nutrition tips", "balanced diet", "healthy recipes" and similar searches.`}
            </TooltipDescriptionWrapper>} placement={'bottom'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '250px'}}><FontAwesomeIcon color={fromDrawer ? '#121212' : '#DADADA'} icon={faSquareQuestion} style={{fontSize: '12px'}}/> </Tooltip></BoxTitle>
            {loadingKeywordMainDetails ? <SkeletonRingLoader backgroundColor='transparent'/> : <BoxMainContent>
              <BoldValue fromDrawer={fromDrawer}>{metricsData?.topicalSearchVolume ? formatLargeNumber(metricsData?.topicalSearchVolume, 1)?.toString()?.replace('.0', '') : '0'}</BoldValue>
            </BoxMainContent>}
            {!loadingKeywordMainDetails && <>
              <BoxTitle fromDrawer={fromDrawer}>Traffic Potential&nbsp;&nbsp; <Tooltip title={<TooltipDescriptionWrapper>
                {`Traffic Potential represents the total estimated search volume (SV) accumulated from all Keyword Variations, Related Keywords, and Questions associated with the primary keyword.  This metric reflects the combined organic traffic potential for a website if it ranks in the top position for all ${getKeywordDetailList?.keywords?.length} potential keywords.`}
              </TooltipDescriptionWrapper>} placement={'bottom'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px'}}><FontAwesomeIcon color={fromDrawer ? '#121212' : '#DADADA'} icon={faSquareQuestion} style={{fontSize: '12px'}}/> </Tooltip></BoxTitle>
              <>
                <BoxMainContent>
                  <BoldValue fromDrawer={fromDrawer}>{metricsData?.trafficPotential ? formatLargeNumber(metricsData?.trafficPotential, 1)?.toString()?.replace('.0', '') : '0'}</BoldValue>
                </BoxMainContent>
                {getSerpOverviewDetails?.topResult?.displayedLink && getSerpOverviewDetails?.topResult?.link ? <><BoxDescription fromDrawer={fromDrawer}>Top ranking result: &nbsp;&nbsp; <Tooltip title={<TooltipDescriptionWrapper>
                  {`The web page URL currently ranking in position 1 for this keyword.`}
                </TooltipDescriptionWrapper>} placement={'bottom'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px'}}><FontAwesomeIcon color={fromDrawer ? '#121212' : '#DADADA'} icon={faSquareQuestion} style={{fontSize: '12px'}}/></Tooltip></BoxDescription>
                <WrapperForLink href={getSerpOverviewDetails?.topResult?.link} target='_blank'>{truncate(getSerpOverviewDetails?.topResult?.displayedLink, 30)}</WrapperForLink></> : ''}
              </>
            </>}
          </>}
      </Box>
      <Box className='box' fromDrawer={fromDrawer} style={{height: 'fit-content'}}>
        {loading && loadingKeywordMainDetails ?<>
          <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'60%'} />
          <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'80%'}
            marginTop= '10px' />
          <SkeletonHorizontalLoaderGray marginTop= '10px' align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'60%'} />
          <SkeletonHorizontalLoaderGray marginTop= '10px' align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'80%'} />
        </> :
          <>
            <div style={{display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap'}}>
              <div>
                <BoxTitle fromDrawer={fromDrawer}>CPC&nbsp;&nbsp;<Tooltip title={<TooltipDescriptionWrapper>
              The price advertisers pay per click to target this keyword in Google Ads campaigns.
                </TooltipDescriptionWrapper>} placement={'bottom'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px'}}> <FontAwesomeIcon icon={faSquareQuestion} color={fromDrawer ? '#121212' : '#DADADA'} style={{fontSize: '12px'}}/> </Tooltip>
                <span>{loading && loadingKeywordMainDetails ? antIcon : ''}</span></BoxTitle>
                {loadingKeywordMainDetails ? <SkeletonRingLoader backgroundColor='transparent'/> :
                  metricsData?.cpc|| metricsData?.cmp || metricsData?.paidClicksPercentage? <>
                    <BoxMainContent>
                      <div style={{display: 'flex', gap: 10, alignItems: 'center'}}>
                        <BoldValue fromDrawer={fromDrawer}>${metricsData?.cpc?.toFixed(1)}</BoldValue>
                        <VerticalBar
                          cpc={metricsData?.cpc}
                          maxCpc={50}
                        />
                      </div>
                    </BoxMainContent>
                    {/* {metricsData?.adsCount ? <BoxDescription>  <Tooltip title={<TooltipDescriptionWrapper>
              The price advertisers pay per click to target this keyword in Google Ads campaigns.
            </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px', width: '300px'}}><span> Total ads: </span></Tooltip> <Tooltip title={metricsData?.adsCount > 0 ? <WrapperTooltip>
              {adsData?.map(item=>{
                return (
                  <>
                    <ToolWrapper>
                      <TitleWrapper>{item?.title}</TitleWrapper>
                      <FlexWrapper>
                        <AddWrapper>ad</AddWrapper>
                        <LinkWrapper>{item?.url}</LinkWrapper>
                      </FlexWrapper>
                      <DescriptionTooltip dangerouslySetInnerHTML={{__html: item?.body}}/>
                      <Divider type='horizontal' style={{background: '#E8E8E8', margin: '9px 0'}}/>
                    </ToolWrapper>
                  </>
                );
              })}
            </WrapperTooltip> : ''} placement={'bottomRight'} color='#fff' overlayStyle={{minWidth: '500px'}} overlayInnerStyle={{borderRadius: '6px', maxHeight: '300px'}}>
              <DescSpan>{metricsData?.adsCount}</DescSpan></Tooltip></BoxDescription> : ''} */}
                    {/* <BoxDescription>Product listing ads: 5</BoxDescription> */}

                    {metricsData?.cmp? <BoxDescription fromDrawer={fromDrawer}><Tooltip title={<TooltipDescriptionWrapper>
                      {`The level of competition between advertisers bidding on the analyzed keyword within their PPC campaigns is what we call Competitive Density. It's shown on a scale from 0 to 1.00, with 1.00 being the most difficult to rank for.`}
                    </TooltipDescriptionWrapper>} placement={'bottom'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px'}}><span>Competitive density:</span></Tooltip> <span style={{color: '#1FAC47'}}>•</span> {formatNumber(metricsData?.cmp, 2)?.toString()?.replace('.00', '') }</BoxDescription> : ''}
                    {metricsData?.paidClicksPercentage ? <><BoxDescription fromDrawer={fromDrawer}><Tooltip title={<TooltipDescriptionWrapper>
                      {`Ads that get more than 30% of total clicks would rate as a "High" paid click rate`}
                    </TooltipDescriptionWrapper>} placement={'bottom'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px'}}><span>Paid clicks:</span></Tooltip> <span style={{color: '#34AEF3'}}>•</span> {metricsData?.paidClicksPercentage?.toFixed(2)}%</BoxDescription>
                    <Tooltip title={
                      <SerpToolTipWrapper>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                          {dummyArray.map((item, idx)=> {
                            if ( idx+1<= metricsData?.paidClicksPercentage *2) {
                              return <Square key={idx} style={{backgroundColor: '#34AEF3', marginRight: '6px'}}></Square>;
                            } else {
                              return <Square key={item} style={{backgroundColor: '#4E5156', marginRight: '6px'}}></Square>;
                            }
                          })}
                        </div>
                        <div style={{display: 'flex', justifyContent: 'space-between', paddingTop: '10px'}}>
                          <div style={{color: '#121212'}}>Low:</div>
                          <div style={{color: '#121212'}}>High:</div>
                        </div>
                        <div style={{display: 'flex', justifyContent: 'space-between'}}>
                          <div style={{display: 'flex'}}>
                            <div style={{color: '#121212'}}>0-3%</div>
                            {/* <div style={{color: '#121212', paddingLeft: '30px'}}>8%</div> */}
                          </div>
                          <div style={{display: 'flex'}}>
                            <div style={{color: '#121212', paddingLeft: '30px'}}>13%+</div>
                          </div>
                        </div>

                      </SerpToolTipWrapper>
                    } placement={'bottom'} color='#fff' overlayStyle={{minWidth: '300px'}} overlayInnerStyle={{borderRadius: '6px', maxHeight: '300px'}}>
                      <div style={{display: 'flex'}}>
                        {dummyArray.map((item, idx)=> {
                          if ( idx+1<= metricsData?.paidClicksPercentage *2) {
                            return <Square key={idx} style={{backgroundColor: '#34AEF3'}}></Square>;
                          } else {
                            return <Square key={item} style={{backgroundColor: '#4E5156'}}></Square>;
                          }
                        })}
                      </div>
                    </Tooltip></> :''}</> :
                    <EmptyStateKeDetail isHeader={true} headDescription={'CPC data not found'}/>
                }
              </div>
              <div>
                <BoxTitle fromDrawer={fromDrawer}>PLA&nbsp;&nbsp;<Tooltip title={<TooltipDescriptionWrapper>
              The top product listing ads that appear for the analyzed keyword.
                </TooltipDescriptionWrapper>} placement={'bottom'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px'}}> <FontAwesomeIcon icon={faSquareQuestion} color={fromDrawer ? '#121212' : '#DADADA'} style={{fontSize: '12px'}}/> </Tooltip>
                <span>{loading && loadingKeywordMainDetails ? antIcon : ''}</span></BoxTitle>
                {loadingKeywordMainDetails ? <SkeletonRingLoader backgroundColor='transparent'/> :
                  adsData?.length || metricsData?.advetisers?
                    <>
                      <BoldValue style={{marginBottom: '12px'}} fromDrawer={fromDrawer}>{adsData?.length || 0}</BoldValue>
                      <BoxDescription fromDrawer={fromDrawer}>
        Total ads: {adsData?.length}&nbsp;<Tooltip title={<WrapperTooltip>
                          {adsData?.map(item=>{
                            return (
                              <>
                                <ToolWrapper>
                                  <TitleWrapper>{item?.title}</TitleWrapper>
                                  <FlexWrapper>
                                    <AddWrapper>ad</AddWrapper>
                                    <LinkWrapper><a href={item?.url} target='_blank' rel='noreferrer'>{item?.url}</a></LinkWrapper>
                                  </FlexWrapper>
                                  <DescriptionTooltip dangerouslySetInnerHTML={{__html: item?.body}}/>
                                  <Divider type='horizontal' style={{background: '#E8E8E8', margin: '9px 0'}}/>
                                </ToolWrapper>
                              </>
                            );
                          })}
                        </WrapperTooltip>} placement={'bottomLeft'} color='#fff' overlayClassName='adsTooltipResponsive' overlayInnerStyle={{borderRadius: '6px', maxHeight: '300px'}}>
                          <DescSpan>{adsData?.length ? 'view' : ''}</DescSpan>
                        </Tooltip>
                      </BoxDescription>
                      {metricsData?.advetisers ? <BoxDescription fromDrawer={fromDrawer}> <Tooltip title={<TooltipDescriptionWrapper>
                        {`This is the total number of advertisers we've seen over the last 6 months for this keyword.`}
                      </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px'}}><span>Advertisers:</span></Tooltip> {metricsData?.advetisers}</BoxDescription> :'' }
                    </> : <EmptyStateKeDetail isHeader={true} headDescription={'Ads data not found'}/>
                }
              </div>
            </div>
          </>}
      </Box>
      {/* <Box>
        {loadingKeywordMainDetails ?<>
          <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'60%'} />
          <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'80%'}
            marginTop= '10px' />
          <SkeletonHorizontalLoaderGray marginTop= '10px' align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'60%'} />
          <SkeletonHorizontalLoaderGray marginTop= '10px' align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'80%'} />
        </> :
          <>
            <BoxTitle>Product listing Ads&nbsp;&nbsp;<Tooltip title={<TooltipDescriptionWrapper>
              The top product listing ads that appear for the analyzed keyword.
            </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px', width: '300px'}}> <FontAwesomeIcon icon={faSquareQuestion} color='#DADADA' style={{fontSize: '12px'}}/> </Tooltip>
            <span>{loadingKeywordMainDetails ? antIcon : ''}</span></BoxTitle>
            {adsData?.length || metricsData?.advetisers? <>
              <BoldValue>{adsData?.length || 0}</BoldValue>
              <BoxDescription>
        Total ads: {adsData?.length}&nbsp;<Tooltip title={<WrapperTooltip>
                  {adsData?.map(item=>{
                    return (
                      <>
                        <ToolWrapper>
                          <TitleWrapper>{item?.title}</TitleWrapper>
                          <FlexWrapper>
                            <AddWrapper>ad</AddWrapper>
                            <LinkWrapper>{item?.url}</LinkWrapper>
                          </FlexWrapper>
                          <DescriptionTooltip dangerouslySetInnerHTML={{__html: item?.body}}/>
                          <Divider type='horizontal' style={{background: '#E8E8E8', margin: '9px 0'}}/>
                        </ToolWrapper>
                      </>
                    );
                  })}
                </WrapperTooltip>} placement={'bottomRight'} color='#fff' overlayStyle={{minWidth: '500px'}} overlayInnerStyle={{borderRadius: '6px', maxHeight: '300px'}}>
                  <DescSpan>{adsData?.length ? 'view' : ''}</DescSpan>
                </Tooltip>
              </BoxDescription>
              {metricsData?.advetisers ? <BoxDescription> <Tooltip title={<TooltipDescriptionWrapper>
                {`This is the total number of advertisers we've seen over the last 6 months for this keyword.`}
              </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px', width: '300px'}}><span>Advertisers:</span></Tooltip> {metricsData?.advetisers}</BoxDescription> :'' }
            </> : <EmptyStateKeDetail isHeader={true} headDescription={'Ads data not found'}/>
            }
          </>}
      </Box> */}
    </CardsContainer>
    <CreateList title={titleModel} buttonName={buttonName} listName={listName} setListName={setListName} setNewKeyword={setNewKeyword} newKeyword={newKeyword} selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry}/>
    <KeDeleteModal isOpen={openKeywordDeleteModal} onDeleteKeyword={onDeleteKeyword} closeModal={closeModal} loading={deleteKeywordLoading}/>

  </Container>;
});

// const TopSectionWrapper = styled.div`
// padding: 0 10px;
// height: 26px;
// background: #4E5156;
// border-radius: 11px;
// display: flex;
// color: #E8E8E8;
// font-weight: 400;
// font-size: 14px;
// line-height: 17px;
// justify-content: center;
// align-items: center;
// margin-right: 9px;
// width: fit-content;
// `;
const SerpToolTipWrapper = styled.div`
padding: 10px;
`;
const SerpHeading = styled.div`
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  color: #121212;
`;


const ToolWrapper = styled.div`
padding-left: 20px;
padding-right: 20px;
`;
// const SearchEngineWrapper = styled.div`
// font-weight: 400;
// font-size: 12px;
// line-height: 15px;
// letter-spacing: -0.01em;
// color: #34AEF3;
// `;
const WrapperForLink = styled.a`
  font-weight: 400;
  font-size: 12px;
  line-height: 12px !important;
  color: #34AEF3;
`;
const Container = styled.div<{fromDrawer?: boolean}>`
  background-color: ${p => p.fromDrawer ? 'transparent' : '#1F2125'};
  padding: ${p => p.fromDrawer ? '0 0 40px 0' : '40px 40px 120px 40px'};
  @media screen and (max-width: 768px) {
   ${p => p.fromDrawer ? '': 'padding: 16px 16px 120px'}
  }
`;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  row-gap: 8px;

`;
const LinkWrapper = styled.a`
  padding-left: 5px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #16611A;
`;

const HeadingContainer = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
`;
const FontAwesomeIconStyled = styled(FontAwesomeIcon)`

  animation: spin infinite 1s linear;
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`;

const SerpContainer = styled.div<{fromDrawer?: boolean}>`
  span {
    color: ${p => p.fromDrawer ? '#121212' : '#E8E8E8'};
  }
  svg {
    margin-right: 8px;
  }
`;
const SerpToolTipContainer = styled.div`
  span {
    color: #121212;
  }
  svg {
    margin-right: 8px;
  }
`;
const Heading = styled.div`
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  margin-left: 15px;
  margin-right: 12px;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    margin-left: 0;
    margin-right: 5px;
    font-size: 18px;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;
const AddWrapper = styled.div`
padding:  1px 2px;
  font-weight: 400;
  font-size: 11px;
  line-height: 13px;
  border: 1px solid #16611A;
  border-radius: 5px;
  color: #16611A;
`;
const ButtonStyled = styled(Button)`
  border: 1px solid #4E5156;
  margin: 0 !important;
  height: 32px;
`;
const Square = styled.div`
  min-width: 4px;
  margin-top: 10px;
  height: 15px;
  border-radius: 20px;
  cursor: pointer;
  margin-right: 4px;

`;
const SubWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 0;
`;
const FlexWrapper = styled.div`
  display: flex;
  padding-top: 4px;
  align-items: center;
`;
const DescriptionTooltip = styled.div`
    padding-top: 5px;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #4D5156;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    margin-top: 9px;
 `;
const LastUpdate = styled.div`
margin-right: 10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-align: right;
  color: #A3A4A4;
  white-space: nowrap;
`;

const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  /* justify-content: space-between; */
  margin-top: 16px;

`;

const Box = styled.div<{difficulty?: any; width?: any; fromDrawer?: boolean}> `
  min-width: 225px;
  width: ${p=>p?.width};
  background:${p=>p?.fromDrawer ? '#fff' : p?.difficulty >= 0 && p?.difficulty <= 10 ? 'linear-gradient(110.83deg, rgba(31, 172, 71, 0.07) 14.41%, rgba(40, 43, 47, 0) 35.4%, rgba(0, 0, 0, 0) 35.4%), #282B2F' : p=>p?.difficulty <= 30 && p?.difficulty > 10 ? 'linear-gradient(110.83deg, rgba(191, 225, 94, 0.07) 14.41%, rgba(40, 43, 47, 0) 35.4%, rgba(0, 0, 0, 0) 35.4%), #282B2F' : p=>p?.difficulty <= 70 && p?.difficulty > 30? 'linear-gradient(110.83deg, rgba(255, 133, 54, 0.07) 14.41%, rgba(40, 43, 47, 0) 35.4%, rgba(0, 0, 0, 0) 35.4%), #282B2F' : p=>p?.difficulty <= 100 && p?.difficulty > 70? 'linear-gradient(110.83deg, rgba(244, 67, 67, 0.07) 14.41%, rgba(40, 43, 47, 0) 35.4%, rgba(0, 0, 0, 0) 35.4%), #282B2F' :'#282B2F'};
  border-radius: 8px;
  padding: 20px 25px;
  @media screen and (max-width: 560px) {
    padding: 10px 12px !important;
  }
  @media screen and (max-width: 640px) {
    height: fit-content !important;
    min-height: auto !important;
  }
  height: 200px;
  &.box{
   min-height: 200px;

   &:nth-child(1){
    flex-grow: 1;
    flex: 28%;
    @media (max-width: 1100px) {
      flex:40%;
    }
    @media (max-width: 710px) {
    flex-grow: 1;
    flex: 100%;
   }
  }
   &:nth-child(2){
    flex-grow: 1;
    flex: 25%;
    @media (max-width: 1707px) {
      flex:20%;
    }
    @media (max-width: 1100px) {
      flex:35%;
    }
    @media (max-width: 710px) {
    flex-grow: 1;
    flex: 100%;
   }
   }
   &:nth-child(3){
    flex-grow: 1;
    flex: 15%;
    @media (max-width: 1100px) {
      max-width: 15%;
    }
    @media (max-width: 710px) {
    flex-grow: 1;
    flex: 100%;
    max-width: 100%;
   }
   }
   &:nth-child(4){
    flex-grow: 1;
    /* flex:30%; */
    @media (min-width: 1810px) {
      flex:30%;
      max-width: 30%;
    }
    @media (max-width: 1695px) {
      flex:25%;
      max-width: 25%;
    }
    @media (max-width: 1590px) {
      flex:28%;
      max-width: 33%;
    }
    @media (max-width: 1220px) {
      flex:28%;
      max-width: 33%;
    }
    @media (max-width: 1100px) {
      max-width: 100%;
    }
    @media (max-width: 710px) {
    flex-grow: 1;
    flex: 100%;
   }
   }
}
`;

const BoxTitle = styled.div<{fromDrawer?: boolean}>`
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  text-transform: uppercase;
  color: ${p => p.fromDrawer ? '#121212' : '#E8E8E8'};
`;

const BoldValue = styled.div<{fromDrawer?: boolean}>`
  font-weight: 600;
font-size: 24px;
line-height: 30px;
color: ${p => p.fromDrawer ? '#121212' : '#FFFFFF'};
`;

const BoxDescription = styled.div<{fromDrawer?: boolean}>`
  font-weight: 400;
  font-size: 14px;
  line-height: 15px;
  letter-spacing: -0.01em;
  color: ${p => p.fromDrawer ? '#121212' : '#A3A4A4'};
  margin-bottom: 8px;
  @media screen and (max-width: 768px) {
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 0 !important;
  }
`;

const BoxMainContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`;

const DescSpan = styled.span`
color: #34AEF3;
text-decoration: underline;
cursor: pointer;
`;

const WrapperTooltip = styled.div `
  max-height: 280px;
  overflow: auto;
  width: 486px;
  &::-webkit-scrollbar {
      height: 5px;
      width: 5px;
    }
  
    &::-webkit-scrollbar-thumb {
      background: rgba(138,138,138,0.32);
    }
  
    &::-webkit-scrollbar-track {
      background: rgba(138,138,138,0.12);
    }
  @media screen and (max-width: 800px) {
    width: auto !important;
  }
`;

const TitleWrapper = styled.div`
font-weight: 400;
font-size: 15px;
line-height: 18px;
color: #200EA9;
padding-top: 14px;
`;
const TooltipDescriptionWrapper = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #121212;
  padding: 5px;
`;
const KeywordLabelHeading = styled.div<{fromDrawer?: boolean}>`
  font-weight: 600;
  font-size: 18px;
  padding-bottom: 11px;
  line-height: 22px;
  color: ${p => p.fromDrawer ? '#121212' : '#FFFFFF'};
  @media screen and (max-width: 768px) {
    font-size: 16px;
    padding-bottom: 6px;
  }
`;

const DropDownWrapper = styled.div`
  overflow-y: auto !important;
  max-height: 196px !important;
  min-height: fit-content;
  cursor: pointer;
 div:first-child{
  &:hover{
  border-radius: 8px 8px 0px 0px;
}

}
div:hover{
  background: #2D6CCA25;
}
div:last-child{
  &:hover{
  /* background: #2D6CCA25; */
  border-radius: 0px 0px 8px 8px;
}
}
&::-webkit-scrollbar {
      height: 5px;
      width: 5px;
    }
  
    &::-webkit-scrollbar-thumb {
      background: rgba(138,138,138,0.32);
    }
  
    &::-webkit-scrollbar-track {
      background: rgba(138,138,138,0.12);
    }



`;

const WrapperDropDown = styled.div<{last?: boolean}>`
font-weight: 400;
font-size: 14px;
line-height: 22px;
color: #121212;
border-bottom: ${p=>p?.last ? 'unset' : '1px solid #f6f6f6'};
padding: 5px 15px;
`;
const IntnetWrapper = styled.div`
display: flex;
margin-top: 9px;
align-items: center;
flex-wrap: wrap;
gap: 8px;
`;
const IntentText = styled.div<{fromDrawer?: boolean}>`
width: 86px;
height: 16px;
font-weight: 400;
font-size: 13px;
line-height: 16px;
color: ${p => p.fromDrawer ? '#121212' : '#A3A4A4'};
margin-left: ${p => p.fromDrawer ? '2px' : '40px'};
@media screen and (max-width: 640px) {
  margin-left: 0 !important;
  white-space: nowrap;
}
`;
const Intent = styled.div<{intent: any}>`
display: flex;
justify-content: center;
align-items: center;
width: fit-content;
padding: 4px 10px;
height: 23px;
border-radius: 24px;
text-transform: capitalize;
font-weight: 500;
font-size: 13px;
line-height: 16px;
background: ${p=> p?.intent?.background};
color: ${p=> p?.intent?.color};
`;

const GlobeStyled = styled(Globe)<{fromDrawer?: boolean}>`
height: 16px;
width: 16px;
color: ${p => p.fromDrawer ? '#121212' : '#fff'};
`;
